import { EntityId, EntityIdParams, Nullable } from '@Models';

export class MagicSpellView extends EntityId<number> {
  pathName: string;
  pathLogo: string;
  castingValue: Nullable<string>;
  effect: Nullable<string>;
  typeLvl: string;
  targets: string[];
  duration: string;

  constructor(params: MagicSpellViewParams) {
    super(params);

    this.pathName = params.pathName;
    this.pathLogo = params.pathLogo;
    this.castingValue = params.castingValue;
    this.effect = params.effect;
    this.typeLvl = params.typeLvl;
    this.targets = params.targets;
    this.duration = params.duration;
  }
}

export type MagicSpellViewParams = EntityIdParams<number> & {
  pathName: string;
  pathLogo: string;
  castingValue: Nullable<string>;
  effect: Nullable<string>;
  typeLvl: string;
  targets: string[];
  duration: string;
};
